import { faClipboardList, faPlus, faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Icon } from "@iconify/react";
import type React from "react";
import { useState } from "react";
import MappingsList from "./MappingsList";
import PokemonGrid from "./PokemonGrid";

interface LeftSidebarProps {
  pokemon: string[];
  selectedPokemon: string | null;
  setSelectedPokemon: (pokemon: string | null) => void;
  pokemonSearch: string;
  setPokemonSearch: (search: string) => void;
  mappings: Map<string, string>;
  removeMapping: (text: string) => void;
  clearAllMappings: () => void;
  addMapping: (text: string, pokemon: string) => void;
  textInput: string;
  setTextInput: (text: string) => void;
  showShiny: boolean;
  setShowShiny: (show: boolean) => void;
}

function LeftSidebar({
  pokemon,
  selectedPokemon,
  setSelectedPokemon,
  pokemonSearch,
  setPokemonSearch,
  mappings,
  removeMapping,
  clearAllMappings,
  addMapping,
  textInput,
  setTextInput,
  showShiny,
  setShowShiny,
}: LeftSidebarProps): React.JSX.Element {
  console.log('LeftSidebar render - selectedPokemon:', selectedPokemon);
  
  const handleAddMapping = (): void => {
    const text = textInput.trim();
    if (!text) {
      alert("Please enter a word or phrase to map.");
      return;
    }
    if (!selectedPokemon) {
      alert("Please select a Pokémon first.");
      return;
    }

    addMapping(text, selectedPokemon);
    setTextInput("");
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === "Enter") {
      handleAddMapping();
    }
  };
  return (
    <aside className="sidebar sidebar-left">
      <div className="flex-1 flex flex-col min-h-0">
        <div className="p-4 border-b border-border-primary">
          <div className="flex items-center gap-2 mb-2">
            <Icon icon="mdi:pokeball" className="text-primary w-5 h-5" />
            <h3 className="card-title">Select Pokémon</h3>
          </div>
          <div className="flex items-center gap-3 mb-3">
            <input
              type="text"
              value={pokemonSearch}
              onChange={(e) => setPokemonSearch(e.target.value)}
              placeholder="Search..."
              className="form-control flex-1"
            />
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={showShiny}
                onChange={(e) => setShowShiny(e.target.checked)}
                className="checkbox"
              />
              <span className="text-sm text-primary font-medium">Shiny</span>
            </label>
          </div>
        </div>
        <PokemonGrid
          pokemon={pokemon}
          selectedPokemon={selectedPokemon}
          setSelectedPokemon={setSelectedPokemon}
          showShiny={showShiny}
        />
      </div>

      <div className="p-4 border-b border-border-primary">
        <div className="section-header">
          <FontAwesomeIcon icon={faPlus} className="text-primary w-5 h-5" />
          <h3 className="section-title">Map Phrase</h3>
        </div>
        <div className="input-group">
          <input
            type="text"
            value={textInput}
            onChange={(e) => setTextInput(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Enter word or phrase..."
            className="form-control"
          />
          <button
            type="button"
            onClick={handleAddMapping}
            className="btn-primary w-full"
            disabled={!selectedPokemon || !textInput.trim()}
          >
            {selectedPokemon && (
              <FontAwesomeIcon 
                icon={faCheck} 
                className="mr-2"
              />
            )}
            Map to {selectedPokemon ? selectedPokemon.charAt(0).toUpperCase() + selectedPokemon.slice(1).toLowerCase() : 'Pokemon'}
          </button>
        </div>
      </div>

      <div className="flex-1 flex flex-col min-h-0">
        <div className="p-4 border-b border-border-primary">
          <div className="flex items-center justify-between">
            <div className="section-header">
              <FontAwesomeIcon icon={faClipboardList} className="text-primary w-5 h-5" />
              <h3 className="section-title">Mappings</h3>
            </div>
            <button
              type="button"
              onClick={clearAllMappings}
              className="btn-danger btn-sm"
            >
              <FontAwesomeIcon icon={faXmark} />
              Clear All
            </button>
          </div>
        </div>
        <MappingsList mappings={mappings} removeMapping={removeMapping} />
      </div>
    </aside>
  );
}

export default LeftSidebar;
